import { render, staticRenderFns } from "./App3D.vue?vue&type=template&id=700a5c52"
import script from "./App3D.vue?vue&type=script&lang=js"
export * from "./App3D.vue?vue&type=script&lang=js"
import style0 from "./App3D.vue?vue&type=style&index=0&id=700a5c52&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports